// extracted by mini-css-extract-plugin
export default {"small":"ProjectListItemIcons_small__56Acc"};